module.exports = __webpack_public_path__ + "img/mapa-acceso.86456e7f.png";